module.exports = __webpack_public_path__ + "img/u3313.b20a242d.png";